import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { KanbanBoardColumn } from './column';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../../Companies/constants';
import styles from './boardMobile.module.css';
import { selectKanbanBoardColumnCells } from '../selectors';

const Container = styled.div``;
/* eslint-disable react/prefer-stateless-function */
class KanbanBoardMobileCarouselItemComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  get cells() {
    return this.props.cells;
  }

  render() {
    if (this.props.hideOnEmpty && !this.cells?.length) return null;

    return (
      <div className={styles.kanbanBoardContainer}>
        <KanbanBoardColumn
          board_id={this.props.board_id}
          column={this.props.column}
          onChange={this.props.onChange}
          filter={this.props.filter}
        />
      </div>
    );
  }
}

KanbanBoardMobileCarouselItemComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    cells: selectKanbanBoardColumnCells(ownProps.boards_id, ownProps.column.id),
    work: selectWorks([REQUEST_COMPANY_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardMobileCarouselItem = compose(withConnect, withRouter)(KanbanBoardMobileCarouselItemComp);
